import {UseMedia} from 'hooks/useMedia';
import {useState} from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import {
  ChallengersInfo,
  FOOTER,
  JudgesInfo,
  Prizeinfo,
  SpeakersInfo,
  TOP_SECTION,
  TeamInfo,
  frequentlyAskedQuestions,
  sponsorLogos
} from '../../Module/General';
import {
  Anuncios,
  CdCSectionAbout,
  Logo,
  LogoSectionAbout
} from '../../components/About/index.jsx';
import {Accordion} from '../../components/Accordian/index.jsx';
import Birds from '../../components/Animation';
import Footer from '../../components/Footer/index.jsx';
import {Myinfo} from '../../components/Landing/index.jsx';
import {FirstPrize, PrizeHeading} from '../../components/Prizes/index.jsx';
import Media from '../../components/Socials/index.jsx';
import {
  Sponsor,
  SponsorUS,
  SponsorsHead
} from '../../components/Sponsors/sponsors.jsx';
import {
  Challenger,
  JoinTeam,
  Judge,
  Member,
  Speaker
} from '../../components/Team';
import './about.css';
import pattern from './assets/pattern4.png';

const SponsorGroup = (props, index) => {
  return (
    <Row key={index}>
      {props.map((s, i) => (
        <Col key={i} className="" sm={12} lg={4} md={6}>
          {' '}
          <Sponsor srcx={s.src} />{' '}
        </Col>
      ))}
    </Row>
  );
};

// Prize group
const PrizeGroup = (props, index) => {
  return (
    <Row key={index}>
      {props.map((s, i) => (
        <Col key={i} className="" sm={12} lg={4} md={4}>
          <FirstPrize
            icon={s.icon}
            type={s.type}
            content={s.content}
            video={s.video}
            integrantes={s.integrantes}
          />
        </Col>
      ))}
    </Row>
  );
};

// Prize group ending
const TeamMembers = (props, index) => {
  return (
    <Row key={index} className="members">
      {props.map((s, i) => (
        <Col key={i} className="" sm={12} lg={3} md={3}>
          <Member info={s} />
        </Col>
      ))}
    </Row>
  );
};

const JudgesMembers = (props, index) => {
  return (
    <Row key={index} className="members">
      {props.map((s, i) => (
        <Col key={i} className="" sm={12} lg={3} md={3}>
          <Judge info={s} />
        </Col>
      ))}
    </Row>
  );
};

const SpeakersMembers = (props, index) => {
  return (
    <Row key={index} className="members">
      {props.map((s, i) => (
        <Col key={i} className="" sm={12} lg={3} md={3}>
          <Speaker info={s} />
        </Col>
      ))}
    </Row>
  );
};

const ChallengersMembers = (props, index) => {
  return (
    <Row key={index} className="members">
      {props.map((s, i) => (
        <Col key={i} className="" sm={12} lg={3} md={3}>
          <Challenger info={s} />
        </Col>
      ))}
    </Row>
  );
};

const FrequentlyAsked = (props, index) => {
  return (
    <Row key={index} className="sf">
      {props.map((s, i) => (
        <Col key={i} sm={12} lg={6} md={6}>
          <Accordion panels={s} />
        </Col>
      ))}
    </Row>
  );
};

export default function HomePage() {
  const [media, setMedia] = useState();
  UseMedia('min-width', 1000, setMedia);

  return (
    <div className="Whole_div" style={{backgroundImage: `url(${pattern})`}}>
      <div className="color_sectiom" id="home">
        <Container fluid>
          <Row className="Row info">
            <Col className="info-div" sm={12} lg={8} md={8}>
              <Myinfo />
            </Col>
            <Col className="d-image" sm={12} lg={4} md={4}>
              <Logo />
            </Col>
          </Row>

          <Row className="mediaInfo">
            <Col className="" sm={12} lg={12} md={12}>
              <Media />
            </Col>
          </Row>
        </Container>
      </div>
      <Container fluid>
        {/* Logo section  */}
        <Row className=" logoSection">
          <Col className="info-div" sm={12} lg={8} md={8}>
            <LogoSectionAbout />
          </Col>
          <Col className="info-div" sm={12} lg={4} md={4}>
            {/*<MyCalender />
            <img className="Logo" src={fases_img} alt="Limbohacks" />*/}
            <Anuncios />
          </Col>
        </Row>

        {/* ********Frequently asked Questions here ***** */}
        <div className="Myfaqs" id="faq">
          {frequentlyAskedQuestions.map(FrequentlyAsked)}
          {/* ********Frequently asked Questions ending here ***** */}
        </div>

        {/* CdC section  */}
        <Row className="cdcSection" id="cdc">
          <CdCSectionAbout />
        </Row>

        {/* ********Prizes here ***** */}
        <Row className="prizesection" id="prizes">
          <PrizeHeading type="Premios" />
          {Prizeinfo.map(PrizeGroup)}
        </Row>
        {/* ********Prizes ending here *****

        <Row className="prizesection non-coding">
          <PrizeHeading type="Otros Beneficios" />
          <h2>Próximamente</h2>
        </Row>
        */}

        {/* ********Sponsors here ***** */}

        <Row className="sponsorSection" id="sponsors">
          <SponsorsHead />
          <SponsorUS />
          {sponsorLogos.map(SponsorGroup)}
        </Row>
        {/* ********Sponsors ending here ***** */}

        {media && <Birds top="120vh" left="0vh" type="" />}

        {/* ********Team here ***** */}
        <h1 id="team">Nuestro Equipo</h1>
        {FOOTER.JOIN_TEAM.required && (
          <JoinTeam
            placeholder="Únete a nuestro equipo"
            formLink={TOP_SECTION.TEAM_FORM_LINK}
            content="Te presentamos el equipo organizador Co-Afina 2023"
          />
        )}
        {TeamInfo.map(TeamMembers)}
        {/* ********Team ending here ***** */}

        {/* ********Judges here ***** 

        <h1 id="team">Jueces</h1>
        {FOOTER.JOIN_TEAM.required && (
          <JoinTeam
            placeholder="Postúlate"
            formLink={TOP_SECTION.JUDGES_FORM_LINK}
            content="Interesado en ser juez"
          />
        )}
        {JudgesMembers.map(JudgesInfo)}
        {/* ********Team ending here ***** 
        */}
        <h1 id="judges">Jueces</h1>
        {JudgesInfo.map(JudgesMembers)}

        {/* ********Speakers here ***** */}
        <h1 id="speakers">Speakers</h1>
        {SpeakersInfo.map(SpeakersMembers)}

        {/* ********Speakers here ***** */}
        <h1 id="challengers">Retadores.as</h1>
        {ChallengersInfo.map(ChallengersMembers)}

        {/* ********Speakers here ***** */}
        <h1 id="challengers">Videos Co-Afina</h1>
        <center>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/videoseries?si=cvIBgUPabAiDwFln&amp;list=PLGC_ZB9twAHsNxHq6x5iXEOJ5Xn2RvG6B"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </center>
      </Container>
      <Footer />
    </div>
  );
}
